
















































import { Component, Vue, Prop, Emit } from "vue-property-decorator";

export interface MassActionItem {
    getActionResult(): Promise<any>;
    model: any;
    identifier: string;
}

export type MassActionResult = {
  model: any;
  identifier: string;
  err?: Error;
  result?: any;
};

@Component({})
export class MassActionPerformModal extends Vue {
  @Prop({ required: true })
  items!: MassActionItem[];

  @Prop({required: true})
  titleText!: string;

  @Prop({required: false, default: ""})
  infoText!: string;

  private componentKey = 0;
  private current: MassActionResult | null = null;
  private results: MassActionResult[] = [];
  private isCompleted = false;

  private get progress() {
    if (this.items.length === 0) {
      return 100;
    }
    return (this.results.length / this.items.length) * 100;
  }

  private get remaining() {
    return this.items.length - this.results.length;
  }

  async mounted() {
    const items = [...this.items];
    for (let i = 0; i < items.length; i++) {
      const result: MassActionResult = {
        identifier: items[i].identifier,
        model: { ...items[i].model }
      };
      this.current = result;
      this.componentKey++;
      // await new Promise(resolve => setTimeout(resolve, 1500));
      try {
        result.result = await items[i].getActionResult();
        this.onItemSuccess(result);
      } catch (err) {
        result.err = err;
        this.onItemFailure(result);
      } finally {
        this.current = null;
      }
      this.results = [result, ...this.results];
    }
    this.onComplete(this.results);
  }

  @Emit("complete")
  onComplete(result: MassActionResult[]) {
    this.isCompleted = true;
    return result;
  }

  @Emit("success")
  onItemSuccess(result: MassActionResult) {
    this.onIterationComplete(result);
    return result;
  }

  @Emit("failure")
  onItemFailure(result: MassActionResult) {
    this.onIterationComplete(result);
    return result;
  }

  @Emit("iteration:complete")
  onIterationComplete(result: MassActionResult) {
    this.componentKey++;
    return result;
  }

  @Emit("close")
  onClose() {}
}

export default MassActionPerformModal;
